import { render } from "./ModalUpload.vue?vue&type=template&id=4cb0231f&scoped=true"
import script from "./ModalUpload.vue?vue&type=script&lang=js"
export * from "./ModalUpload.vue?vue&type=script&lang=js"

import "./ModalUpload.vue?vue&type=style&index=0&id=4cb0231f&scoped=true&lang=css"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb0231f"]])

export default __exports__